let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eB7Uk"), load("jMcpk")]).then(() => parcelRequire('bYWX4'));